export enum FileType {
    PDF = 'pdf',
    DOCX = 'docx',
    DOC = 'doc',
}